import { render, staticRenderFns } from "./Finish.vue?vue&type=template&id=5e89f650&scoped=true&lang=pug&"
import script from "./Finish.vue?vue&type=script&lang=js&"
export * from "./Finish.vue?vue&type=script&lang=js&"
import style0 from "./Finish.scss?vue&type=style&index=0&id=5e89f650&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e89f650",
  null
  
)

export default component.exports